import { enablePointerEvents } from '@utils/pointer-events-control';
import { config, resetGameState } from '@js/state';

export default class StartScene extends Phaser.Scene {
  constructor() {
    super({ key: 'StartScene' });
  }

  create() {
    // Enable pointer events so hover states and the cursor work
    enablePointerEvents();

    const { width, height } = config;

    this.cameras.main.setBackgroundColor('#D6F5FF');

    // Title-screen warehouse view — Figma node 168:146.
    const bgKey = this.textures.exists('bg-start') ? 'bg-start' : 'bg-out';
    if (this.textures.exists(bgKey)) {
      const bg = this.add.image(width / 2, height / 2, bgKey);
      const sx = width / (bg.width || 1);
      const sy = height / (bg.height || 1);
      bg.setScale(Math.max(sx, sy));
    }

    // Play CTA — baked-text sprite (btn-play / btn-play-hover).
    this.buildCtaButton(width / 2, height - 190, 'btn-play', () => this.startGame());

    resetGameState();
  }

  buildCtaButton(x, y, key, onClick, opts = {}) {
    // ─── Pre-flight ───
    // Inputs: pointerdown/up on the button sprite.
    // State mutated: button fires onClick → scene.start (one-shot).
    // Re-entry guards: disableInteractive() on first pointerup before onClick.
    // Cleanup: sprite is destroyed when scene shuts down.
    // Manually verified: [x] same-element double click [x] click during animation [x] rapid clicks
    const hoverKey = `${key}-hover`;
    const h = opts.height || 48;

    const bg = this.add
      .image(x, y, key)
      .setOrigin(0.5)
      .setInteractive({ useHandCursor: true });

    // Maintain aspect ratio at the canonical 48px CTA height.
    const w = (bg.width / bg.height) * h;
    bg.setDisplaySize(w, h);

    const hasHoverTexture = this.textures.exists(hoverKey);
    bg.on('pointerover', () => {
      if (hasHoverTexture) bg.setTexture(hoverKey);
      bg.setDisplaySize(w, h);
    });
    bg.on('pointerout', () => {
      bg.setTexture(key);
      bg.setDisplaySize(w, h);
    });
    bg.on('pointerdown', () => bg.setDisplaySize(w * 0.97, h * 0.97));
    bg.on('pointerup', () => {
      bg.disableInteractive();
      bg.setDisplaySize(w, h);
      onClick();
    });

    return { bg };
  }

  startGame() {
    this.cameras.main.fadeOut(400, 0, 0, 0);
    this.cameras.main.once('camerafadeoutcomplete', () => {
      this.scene.start('GameScene');
    });
  }
}
